module.exports = __webpack_public_path__ + "media/images/Tamil-matrimony-banner-6749326b20be59bb8a9b19bf5690f511.jpg";